import { CoreUser } from 'fitify-types/src/types/core/user'
import type { UseSubscriptionConfig } from 'fitify-ui-onboarding/src/hooks/subscription/useSubscriptionConfig'
import type { MetaDataProps } from 'fitify-ui-onboarding/src/utils/meta-tags'
import { lazy } from 'react'

import { SubscriptionPageLoader } from 'sections/subscription/SubscriptionPageLoader'

const FastspringSubscriptionPage = lazy(
  () => import('sections/subscription/FastspringSubscriptionPage')
)
const FlexSubscriptionPage = lazy(
  () => import('sections/subscription/FlexSubscriptionPage')
)
const PaddleSubscriptionPage = lazy(
  () => import('sections/subscription/PaddleSubscriptionPage')
)
const StripeSubscriptionPage = lazy(
  () => import('sections/subscription/StripeSubscriptionPage')
)

type Props = {
  gateway?: CoreUser.Subscription.Gateway
  metaData: MetaDataProps
} & UseSubscriptionConfig

export const SubscriptionPageGateway = ({
  gateway,
  metaData,
  pageConfig,
  subscriptionPlanConfigs,
}: Props) => {
  switch (gateway) {
    case CoreUser.Subscription.Gateway.Flex:
      return (
        <FlexSubscriptionPage
          metaData={metaData}
          pageConfig={pageConfig}
          subscriptionPlanConfigs={subscriptionPlanConfigs}
        />
      )
    case CoreUser.Subscription.Gateway.Paddle:
      return (
        <PaddleSubscriptionPage
          metaData={metaData}
          pageConfig={pageConfig}
          subscriptionPlanConfigs={subscriptionPlanConfigs}
        />
      )
    case CoreUser.Subscription.Gateway.Stripe:
      return (
        <StripeSubscriptionPage
          metaData={metaData}
          pageConfig={pageConfig}
          subscriptionPlanConfigs={subscriptionPlanConfigs}
        />
      )

    case CoreUser.Subscription.Gateway.Fastspring:
      return (
        <FastspringSubscriptionPage
          metaData={metaData}
          pageConfig={pageConfig}
          subscriptionPlanConfigs={subscriptionPlanConfigs}
        />
      )
    default:
      return (
        <SubscriptionPageLoader metaData={metaData} pageConfig={pageConfig} />
      )
  }
}
